/* Cozy PDP — up/down nav arrows for the vertical thumbnail strip (desktop). */
(function () {
  function svg(dir) {
    var pts = dir === 'up' ? '18 15 12 9 6 15' : '6 9 12 15 18 9';
    return '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="' + pts + '"/></svg>';
  }
  function init() {
    if (!document.body.classList.contains('cozy-pdp')) return;
    if (window.innerWidth < 990) return;
    document.querySelectorAll('.product--thumbnail_slider .thumbnail-slider').forEach(function (ts) {
      var list = ts.querySelector('.thumbnail-list');
      if (!list || ts.querySelector('.cz-thumb-nav')) return;
      function mk(dir) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'cz-thumb-nav cz-thumb-nav--' + dir;
        b.setAttribute('aria-label', dir === 'up' ? 'Scroll thumbnails up' : 'Scroll thumbnails down');
        b.innerHTML = svg(dir);
        b.addEventListener('click', function () {
          list.scrollBy({ top: dir === 'up' ? -170 : 170, behavior: 'smooth' });
        });
        return b;
      }
      var up = mk('up'), down = mk('down');
      ts.insertBefore(up, list);
      ts.appendChild(down);
      function update() {
        var atTop = list.scrollTop <= 2;
        var atEnd = list.scrollTop + list.clientHeight >= list.scrollHeight - 2;
        up.style.visibility = atTop ? 'hidden' : 'visible';
        down.style.visibility = atEnd ? 'hidden' : 'visible';
        var noScroll = list.scrollHeight <= list.clientHeight + 2;
        up.style.display = down.style.display = noScroll ? 'none' : '';
      }
      list.addEventListener('scroll', update);
      window.addEventListener('resize', update);
      update();
    });
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();

/* Configurator accordion — each step collapses to a single row showing the chosen
   value (design #6). Done from the THEME; the app/TAE is untouched. Waits for the
   async-rendered .sc-wrap, survives the configurator's re-render via an observer. */
(function () {
  var forceExpand = {};

  function valOf(step) {
    var sel = step.querySelector('.sc-card.sc-selected,.sc-toggle-row.sc-selected,.sc-swatch.sc-selected');
    var t = '';
    if (sel) {
      var l = sel.querySelector('.sc-card-label,.sc-toggle-label,.sc-swatch-tooltip');
      t = l ? l.textContent : (sel.getAttribute('aria-label') || '');
    } else {
      var dd = step.querySelector('.sc-dropdown');
      if (dd && dd.selectedIndex > 0) t = dd.options[dd.selectedIndex].text;
    }
    return t.split('+')[0].split('$')[0].replace(/\s+/g, ' ').trim();
  }

  function enhance(wrap) {
    var steps = Array.prototype.slice.call(wrap.querySelectorAll('.sc-step'));
    // active step = first one still without a value
    var activeIdx = -1;
    steps.forEach(function (s, i) { if (activeIdx < 0 && valOf(s) === '') activeIdx = i; });

    steps.forEach(function (step, i) {
      var gid = step.dataset.groupId || ('g' + i);
      var hdr = step.querySelector('.sc-step-header');
      if (!hdr) return;
      // the configurator app's own collapse (collapse_steps setting) renders .sc-step-chev —
      // don't add a second accordion on top (avoids double arrows + conflicting click handlers)
      if (hdr.querySelector('.sc-step-chev')) return;
      if (!hdr.querySelector('.cz-step-val')) {
        var v = document.createElement('span'); v.className = 'cz-step-val';
        var c = document.createElement('span'); c.className = 'cz-step-chev';
        c.innerHTML = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"/></svg>';
        hdr.appendChild(v); hdr.appendChild(c);
        hdr.classList.add('cz-step-hdr');
        hdr.addEventListener('click', function (e) {
          if (e.target.closest('.sc-card,.sc-swatch,.sc-toggle-row,.sc-dropdown,a,input,select')) return;
          // clicking a collapsed step expands it; clicking an expanded one re-derives
          forceExpand[gid] = step.classList.contains('cz-collapsed');
          schedule(wrap);
        });
      }
      hdr.querySelector('.cz-step-val').textContent = valOf(step);

      var collapsed;
      if (forceExpand[gid]) collapsed = false;
      else if (valOf(step) !== '') collapsed = true;     // answered → collapsed
      else collapsed = (i !== activeIdx);                // unanswered → open only the active step
      step.classList.toggle('cz-collapsed', collapsed);
    });
  }

  var raf = null;
  function schedule(wrap) {
    if (raf) return;
    raf = requestAnimationFrame(function () { raf = null; runEnhance(wrap); });
  }
  var observer = null, currentWrap = null;
  function runEnhance(wrap) {
    if (observer) observer.disconnect();
    enhance(wrap);
    if (observer) observer.observe(wrap, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
  }

  function setupWrap(wrap) {
    if (wrap.dataset.czAcc) return;
    wrap.dataset.czAcc = '1';
    currentWrap = wrap;
    function clearFE(el) { var st = el && el.closest('.sc-step'); if (st) forceExpand[st.dataset.groupId || ''] = false; }
    wrap.addEventListener('click', function (e) { var o = e.target.closest('.sc-card,.sc-swatch,.sc-toggle-row'); if (o) { clearFE(o); schedule(wrap); } });
    wrap.addEventListener('change', function (e) { if (e.target.closest('.sc-dropdown')) { clearFE(e.target); schedule(wrap); } });
    observer = new MutationObserver(function () { schedule(wrap); });
    runEnhance(wrap);
  }

  function boot() {
    if (!document.body.classList.contains('cozy-pdp')) return;
    var w = document.querySelector('.cozy-pdp .sc-wrap');
    if (w) { setupWrap(w); return; }
    var bodyObs = new MutationObserver(function () {
      var w = document.querySelector('.cozy-pdp .sc-wrap');
      if (w) { bodyObs.disconnect(); setupWrap(w); }
    });
    bodyObs.observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();

/* Cozy PDP — show the price inside the Add-to-cart button: "Add to cart · $1,449". */
(function () {
  function clean(t) { return (t || '').replace(/\s*USD\s*/i, '').replace(/([.,])00(\D|$)/, '$2').replace(/\s+/g, ' ').trim(); }
  function apply() {
    // clean verbose price ("$1,449.00 USD" -> "$1,449") in the panel, guarded vs loops
    document.querySelectorAll('.cozy-pdp .product__info-container .price-item').forEach(function (el) {
      if (/USD/i.test(el.textContent) || /\.\d{2}(\D|$)/.test(el.textContent)) {
        var c = clean(el.textContent);
        if (c) el.textContent = c;
      }
    });
    var btn = document.querySelector('.cozy-pdp .product-form__submit > span') || document.querySelector('.cozy-pdp .product-form__submit');
    var pe = document.querySelector('.cozy-pdp .product__info-container .price-item--regular');
    if (!btn || !pe) return;
    if (!btn.dataset.czBase) btn.dataset.czBase = btn.textContent.split('·')[0].trim();
    var p = clean(pe.textContent);
    btn.textContent = p ? btn.dataset.czBase + ' · ' + p : btn.dataset.czBase;
  }
  function boot() {
    if (!document.body.classList.contains('cozy-pdp')) return;
    apply();
    var pe = document.querySelector('.cozy-pdp .product__info-container .price');
    if (pe) { try { new MutationObserver(apply).observe(pe, { childList: true, subtree: true, characterData: true }); } catch (e) {} }
  }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();
